export const isHomepage = (pageUrl: string) => {
  const slug = pageUrl?.split('?')[0]
  return slug === '/'
}
